module.exports = __webpack_public_path__ + "static/media/3.e100e074.png";